import React, { useEffect, useState, useCallback } from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';
import { alertIcWarning24px } from '@ey-xd/motif-react/assets/icons';
import { SESSION_EXPIRE, LOGOUT_SCREEN } from '@constants/commonConstants';
import { BodyContent, HeaderWrapper, ParagraphStyle } from '@organisms/modals/styles/modalStyles';
import { isMobile } from 'react-device-detect';
import '@styles/commonStyles.css';
import { formatTime } from '../../../util/commonUtil';
import { Current_User, Refresh_Auth_Token } from '@recoil/recoil';
import { useRecoilState, useRecoilValue } from 'recoil';
import { logError } from '@util/commonFunctions';
import { getLogOutStatus } from '@services/commonServices';
import { useNavigate } from 'react-router-dom';

const IDLE_MINUTES = process.env.REACT_APP_SESSION_EXPIRE;
const DISPLAY_MINUTES = process.env.REACT_APP_SESSION_EXPIRE_WARNING;

let activityTimer = 0;

const SessionExpireModal = () => {
  const navigate = useNavigate();
  const [time, setTime] = useState(IDLE_MINUTES); // Time in minutes
  const [showSessionExpireModal, setShowSessionExpireModal] = useState(false);
  const currentUser = useRecoilValue(Current_User);
  const [refreshToken, setRefreshToken] = useRecoilState(Refresh_Auth_Token); //eslint-disable-line

  const handleActivity = useCallback(() => {
    if (!showSessionExpireModal) {
      setTime(IDLE_MINUTES);
    }
  }, []);

  const addEvents = () => {
    document.addEventListener('mousemove', handleActivity);
    document.addEventListener('keydown', handleActivity);
  };

  const removeEvents = () => {
    document.removeEventListener('mousemove', handleActivity);
    document.removeEventListener('keydown', handleActivity);
  };

  useEffect(() => {
    if (time === 0) {
      if (showSessionExpireModal) {
        signOut();
      } else {
        removeEvents();
        setShowSessionExpireModal(true);
        setTime(DISPLAY_MINUTES);
      }
    }
  }, [time]);

  useEffect(() => {
    const timer = () => {
      setTime(prevTime => {
        if (prevTime === 0) {
          clearInterval(activityTimer);
          return prevTime;
        }
        return prevTime - 1;
      });
    };
    addEvents();
    activityTimer = setInterval(timer, 1000);

    return () => {
      removeEvents();
      clearInterval(activityTimer);
    };
  }, []);

  const signOut = () => {
    getLogOutStatus(currentUser?.email)
      .then(() => {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/logout', {
          state: {
            TITLE: LOGOUT_SCREEN.HEADER_TITLE,
            DESCRIPTION: LOGOUT_SCREEN.DESCRIPTION,
            BUTTON_TITLE: LOGOUT_SCREEN.BUTTON_TITLE,
          },
        });
        setShowSessionExpireModal(false);
      })
      .catch(error => {
        logError('getLogOutStatus', error);
      });
  };

  const extendSession = () => {
    setShowSessionExpireModal(false);
    setRefreshToken(true);
    setTime(IDLE_MINUTES);
    addEvents();
  };

  const Header = ({ children }) => <HeaderWrapper>{children}</HeaderWrapper>;
  const bodyContent = (
    <BodyContent>
      <p>{SESSION_EXPIRE.DESCRIPTION1}</p>
      <p>
        {SESSION_EXPIRE.DESCRIPTION2} {formatTime(time)}
      </p>
    </BodyContent>
  );
  const headerTitle = (
    <span style={{ marginLeft: 11, fontSize: 16 }}>{SESSION_EXPIRE.HEADER_TITLE}</span>
  );

  return (
    <>
      <MotifModal
        variant="alt"
        show={showSessionExpireModal}
        onClose={signOut}
        size={isMobile ? 'sm' : 'md'}
        className={isMobile ? 'motif-Modal-mobile' : null}
        focusTrapOptions={{
          initialFocus: false,
        }}
      >
        <MotifModalHeader closeModalButton={true} style={{ position: 'relative' }}>
          <Header>
            <MotifIcon style={{ color: '#FF9831', lineHeight: 1 }} src={alertIcWarning24px} />
            {headerTitle}
          </Header>
        </MotifModalHeader>
        <MotifModalBody>
          <ParagraphStyle> {bodyContent}</ParagraphStyle>
        </MotifModalBody>
        <MotifModalFooter style={{ display: 'flex', justifyContent: 'end' }}>
          <MotifButton variant="secondary" type="button" onClick={extendSession}>
            {SESSION_EXPIRE.BUTTON_TITLE}
          </MotifButton>
        </MotifModalFooter>
      </MotifModal>
      <div style={{ display: 'none' }}>idle Time {time}</div>
    </>
  );
};
export default SessionExpireModal;
